export * from './click-outside.directive';
export * from './custom-dialog.directive';
export * from './ellipsis-tooltip.directive';
export * from './kendo-popup-auto-resize.directive';
export * from './key-event.directive';
export * from './phone-format.directive';
export * from './scroll-event.directive';
export * from './template.directive';
export * from './track-event.directive';

import { ClickOutsideDirective } from './click-outside.directive';
import { CustomDialogDirective } from './custom-dialog.directive';
import { EllipsisTooltipDirective } from './ellipsis-tooltip.directive';
import { KendoPopupAutoResizeDirective } from './kendo-popup-auto-resize.directive';
import { KeyEventDirective } from './key-event.directive';
import { PhoneFormatterDirective } from './phone-format.directive';
import { ScrollEventDirective } from './scroll-event.directive';
import { TemplateDirective } from './template.directive';
import { TrackEventDirective } from './track-event.directive';

export const UI_DIRECTIVES = [
  ClickOutsideDirective,
  CustomDialogDirective,
  EllipsisTooltipDirective,
  KendoPopupAutoResizeDirective,
  KeyEventDirective,
  PhoneFormatterDirective,
  ScrollEventDirective,
  TemplateDirective,
  TrackEventDirective,
] as const;
